var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowsRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrows-rotate",
    d: "M31.867,16a1.133,1.133,0,0,0-1.133,1.133v2.624a7.684,7.684,0,0,0-13.544,2.129,1.134,1.134,0,0,0,2.157.7A5.416,5.416,0,0,1,28.906,21.1H27.333a1.133,1.133,0,1,0,0,2.267h4.533A1.133,1.133,0,0,0,33,22.233v-5.1A1.132,1.132,0,0,0,31.867,16Zm-.786,9.69a1.133,1.133,0,0,0-1.427.729A5.416,5.416,0,0,1,20.094,27.9h1.572a1.133,1.133,0,1,0,0-2.267H17.133A1.133,1.133,0,0,0,16,26.767v5.1a1.133,1.133,0,0,0,2.267,0V29.243a7.657,7.657,0,0,0,13.511-2.129A1.076,1.076,0,0,0,31.08,25.69Z",
    transform: "translate(-16 -16)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRotate);
export default __webpack_public_path__ + "static/media/arrows-rotate.3616910f7a9b2805b7ea30de202e4928.svg";
export { ForwardRef as ReactComponent };